import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportPokerResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportPokerInner() {
    return <PlayerLevelReportBase tab="poker" columnsSettingsViewType="PlayerLevelReportPoker" />;
}

const PlayerLevelReportPokerWithAccess = withAccessCheck(PlayerLevelReportPokerInner, playerLevelReportPokerResource);

export const PlayerLevelReportPoker = withTraceErrorBoundary(PlayerLevelReportPokerWithAccess, ErrorModal);
